import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-modal-pdf',
    templateUrl: './modal-pdf.component.html'
})
export class ModalPdfComponent implements OnInit {

    url: SafeResourceUrl;

    constructor(public dialogRef: MatDialogRef<ModalPdfComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private domSanitizer: DomSanitizer) {}

    ngOnInit(): void {
        this.url = this.sanitizeUrl(this.data.url);
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }

    private sanitizeUrl(url: string) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
